export default __webpack_public_path__ + "static/media/profile.3fb03b1f.png";